import Vue from 'vue'
import Router from 'vue-router'

import home from '@/view/tab/home'
import seach from '@/view/tab/seach'
import center from '@/view/tab/center'
import about from '@/view/tab/about'
import law from '@/view/tab/law'
import key from '@/view/tab/key'
import advert from '@/view/tab/advert'
import city from '@/view/tab/city'

import policy from '@/view/index/policy'
import pdetail from '@/view/index/policy-detail'
import worker from '@/view/index/worker'
import workerDetail from '@/view/index/worker-detail'
import resume from '@/view/index/resume'
import resumeDetail from '@/view/index/resume-detail'
import lease from '@/view/index/lease'
import leaseDetail from '@/view/index/lease-detail'
import bidding from '@/view/index/bidding'
import biddDetail from '@/view/index/bidding-detail'
import skill from '@/view/index/skill'
import skillDetail from '@/view/index/skill-detail'


import buy from '@/view/buy/buy'
import pay from '@/view/buy/pay'

import supplyList from "@/view/supply/list"
import supplyDetail from "@/view/supply/detail"


Vue.use(Router)

const routes = [{
			path: '/',
			name: 'home',
			component: home
		}, {
			path: '/seach',
			name: 'seach',
			component: seach
		}, {
			path: '/policy',
			name: 'policy',
			component: policy
		}, {
			path: '/pdetail',
			name: 'pdetail',
			component: pdetail
		}, {
			path: '/about',
			name: 'about',
			component: about
		},{
			path: '/law',
			name: 'law',
			component: law
		},
    {
    	path: '/key',
    	name: 'key',
    	component: key
    },{
			path: '/advert',
			name: 'advert',
			component: advert
		}, {
			path: '/city',
			name: 'city',
			component: city
		}, {
			path: '/worker',
			name: 'worker',
			component: worker,
		}, {
			path: '/workerDetail',
			name: 'workerDetail',
			component: workerDetail
		}, {
			path: '/resume',
			name: 'resume',
			component: resume
		}, {
			path: '/resumeDetail',
			name: 'resumeDetail',
			component: resumeDetail
		}, {
			path: '/lease',
			name: 'lease',
			component: lease
		}, {
			path: '/leaseDetail',
			name: 'leaseDetail',
			component: leaseDetail
		}, {
			path: '/bidding',
			name: 'bidding',
			component: bidding
		},{
			path: '/biddDetail',
			name: 'biddDetail',
			component: biddDetail
		},{
			path: '/skill',
			name: 'skill',
			component: skill
		}, {
			path: '/skillDetail',
			name: 'skillDetail',
			component: skillDetail
		}, {
			path: '/buy',
			name: 'buy',
			component: buy
		}, {
			path: '/pay',
			name: 'pay',
			component: pay
		}, {
			path: '/center',
			name: 'center',
			component: center
		},
		{
			path: '/supplyList',
			name: 'supplyList',
			component: supplyList
		},
		{
			path: '/supplyDetail',
			name: 'supplyDetail',
			component: supplyDetail
		}
	]
	const router = new Router({
	  base: process.env.BASE_URL,
	  routes,
	  mode:'history',
	});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js